export default {"src":"/_next/static/media/consumables.002d0649.svg","height":17,"width":20,"blurWidth":0,"blurHeight":0};